/*
 * @Description: 
 */
/*
 * @Description: 
 */

/*
 * @Description: 接口api
 */
let baseUrl = process.env.NODE_ENV == 'development' ? 'http://localhost:14690' : '';
//let baseUrl = '';
export default {
  baseUrl: baseUrl,
  getOauth2: baseUrl + '/api/oauth2', // 获取access_token
  getToken: baseUrl + '/user/get_token',
  getdlLogin: baseUrl + '/api/dlLogin', // 度量云通过token获取
  getArticles: baseUrl + '/api/getarticles', // 获取文章列表
  getArticle: baseUrl + '/api/getarticle', // 获取文章详情
  getBranch: baseUrl + '/api/getbranch', // 获取营业网点
  userRegister: baseUrl + '/api/userregister', // 账号注册
  getNotice: baseUrl + '/api/getnotice', // 首页公告
  forgetPwd: baseUrl + '/api/forgetpwd', // 密码修改
  fileUpload: baseUrl + '/api/fileupload', // 文件上传
  getBusinessTypes: baseUrl + '/api/getbusstype', // 获取业务类型
  getSmsCode: baseUrl + '/api/smscode', // 获取验证码

  apiRepair: baseUrl + '/api/repair', // 故障报修(外面用)
  apiSewage: baseUrl + '/api/sewage', // 污水缴费通知单

  serviceRepair: baseUrl + '/service/repair', // 故障报修
  serviceComplain: baseUrl + '/service/complain', // 投诉建议
  serviceLeak: baseUrl + '/service/leak', // 表后设施捡漏申请
  serviceCheck: baseUrl + '/service/check', // 水质监测申请
  serviceRead: baseUrl + '/service/meterwrite', // 网上抄表
  serviceSewage: baseUrl + '/service/sewagefeeapply', // 非居民污水处理费缓交申请

  checkbuss: baseUrl + '/user/checkbuss', // 检查是否存在办理中的业务
  getUserno: baseUrl + '/user/getuserno', // 户号查询-获取验证码
  getUsernoOk: baseUrl + '/user/getusernook', // 户号查询-立即查询
  userBind: baseUrl + '/user/bind', // 户号绑定
  userUnbind: baseUrl + '/user/unbind', // 户号解绑
  userList: baseUrl + '/user/usernolist', // 用户管理
  modifyPwd: baseUrl + '/user/modifypwd', // 密码修改
  userUpdate: baseUrl + '/user/updateuserinfo',//更新微信用户信息
  personTransfer: baseUrl + '/user/persontransfer', // 水表过户
  personCatch: baseUrl + '/user/personnew', // 城乡居民接水服务
  personRemodel: baseUrl + '/user/personremake', // 一户一表改造
  personChange: baseUrl + '/user/personchange', // 客户信息变更
  personReconnect: baseUrl + '/user/personrfix', // 水表复接申请
  personDestroy: baseUrl + '/user/personcancel', // 水表销户申请
  personCheck: baseUrl + '/user/personcheck', // 水表验表申请
  personStop: baseUrl + '/user/personstop', // 水表报停申请
  personNature: baseUrl + '/user/personchangetype', // 用水性质变更
  // 单位业务
  companyTransfer: baseUrl + '/Company/companytransfer',//水表过户
  companyStop: baseUrl + '/Company/CompanyStop',//水表报停
  companyRfix: baseUrl + '/Company/CompanyRfix',//水表复接
  companyCancel: baseUrl + "/Company/CompanyCancel",//水表销户
  companyChangetype: baseUrl + '/Company/CompanyChangetype',//水表用水性质变更
  companyTaxapply: baseUrl + '/Company/CompanyTaxapply',//增值税专票申请
  companyTaxchange: baseUrl + '/Company/CompanyTaxchange',//增值税信息变更
  companyTaxrevoke: baseUrl + '/Company/CompanyTaxrevoke',//增值税信息撤销
  companyRemake: baseUrl + '/Company/CompanyRemake',//一户一表改造
  companyPipemove: baseUrl + '/Company/CompanyPipemove',//管道移位工程
  companyNew: baseUrl + '/Company/CompanyNew',//城乡居民接水
  companyMetermove: baseUrl + '/Company/CompanyMetermove',//水表移位工程
  companyExisting: baseUrl + '/Company/CompanyExisting',//不涉及工程项目报装
  companyBuild: baseUrl + '/Company/CompanyBuild',//新建及改扩建，基建接水项目用水报装
  businessProgress: baseUrl + '/user/getbuss', // 业务办理-受理进度
  butlerProgress: baseUrl + '/user/getservice', // 水管家服务-受理进度
  getUserInfo: baseUrl + '/user/getuserinfo', // 获取用户信息
  getUseWater: baseUrl + '/user/getuseqty', // 用水量查询
  getSewage: baseUrl + '/user/getsewage', // 排污查询
  waterFee: baseUrl + '/user/waterfee', // 水费缴纳
  sewageFee: baseUrl + '/user/sewagefee', // 污水费缴纳
  projectFee: baseUrl + '/user/projectfee', // 工程款缴纳
  queryFee: baseUrl + '/user/queryfee', // 户号查缴
  getConcentration: baseUrl + '/user/getdensity', // 浓度查询
  bigFee: baseUrl + '/user/getbigqty', // 大用户水量
  smallFee: baseUrl + '/user/getsamllqty', // 远传小表水量
  getFeeBill: baseUrl + '/user/getfeebill', // 水费清单
  invoiceApplys: baseUrl + '/user/invoiceapply', // 电子发票申请列表
  invoiceDowns: baseUrl + '/user/invoicelist', // 电子发票下载列表
  invoiceApply: baseUrl + '/user/invoiceapplyok', // 申请开票
  invoiceDownOk: baseUrl + '/user/invoicelistok', // 发票下载
  getContract: baseUrl + '/user/getcontract', // 电子合同列表
  getBussInfo: baseUrl + '/user/getbussinfo', // 获取业务办理详情
  billCancel: baseUrl + '/user/billcancel', // 放弃申请
  getRead: baseUrl + '/user/getmeterwrite', // 网上抄表查询
  modifyRegisterInfo: baseUrl + '/user/modifyinfo', // 注册信息修改
  getWaterType: baseUrl + '/api/getwatertype', // 用水性质获取
  projectFeeReturn: baseUrl + '/user/projectfeereturn', // 工程款缴费退款申请
  scanBindUrl: baseUrl + '/user/bindwechat', // 微信扫码绑定
  getPayUrl: baseUrl + '/user/getpayurl', // 工程款缴费支付链接
}
